import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../header/Header";
import ProgressBar from "../progressBar/ProgressBar";
import {
  CREATION_STEPS,
  PeriodPicker,
  PriceBlock,
  SummaryBar,
  billingFor,
  cartItemFor,
  totalFor,
} from "./OptionParts";
import { addToCart } from "../../redux/actions/CartActions";
import { addToServiceList } from "../../redux/actions/ServiceListActions";
import serviceCode from "../../assets/data/serviceCode.json";
import { formatPrice } from "../../utils/formatPrice";
import "../../views/styles/options.css";

// Main service page of a subscription flow, followed by the options step
function ServicePlanPage({
  serviceKey,
  icon: Icon,
  title,
  lead,
  cardTitle,
  summary,
  prices,
  guide,
  note,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const cart = useSelector((state) => state.cart);

  const fromCart = new URLSearchParams(location.search).get("from") === "cart";
  const [periodicity, setPeriodicity] = useState(
    cart?.[serviceKey]?.periodicity || "mensuel",
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleContinue = async () => {
    await dispatch(
      addToCart({ [serviceKey]: cartItemFor(prices, periodicity) }),
    );
    await dispatch(
      addToServiceList({
        code: serviceCode[serviceKey],
        billing: billingFor(prices, periodicity),
      }),
    );

    navigate(fromCart ? "/options?from=cart" : "/options");
  };

  return (
    <div className="options-page">
      <Header />
      <ProgressBar steps={CREATION_STEPS} currentStep="Services" />

      <div className="container options-container">
        <header className="options-header">
          <h1 className="options-title">{title}</h1>
          <p className="options-lead">{lead}</p>
        </header>

        <article className="option-card service-plan-card">
          <div className="service-plan-head">
            <span className="option-icon" aria-hidden="true">
              <Icon />
            </span>
            <div>
              <h2 className="option-title">{cardTitle}</h2>
              <p className="option-summary">{summary}</p>
            </div>
          </div>

          <div className="option-card-pricing">
            <PeriodPicker value={periodicity} onChange={setPeriodicity} />
            <PriceBlock prices={prices} periodicity={periodicity} />
          </div>

          <ul className="service-plan-list">
            {guide.items.map(({ icon: ItemIcon, title: itemTitle, text }) => (
              <li key={itemTitle}>
                <span className="service-plan-icon" aria-hidden="true">
                  <ItemIcon />
                </span>
                <span className="service-plan-text">
                  <strong>{itemTitle}</strong>
                  <span>{text}</span>
                </span>
              </li>
            ))}
          </ul>
          {note && <p className="service-plan-note">{note}</p>}
        </article>
      </div>

      <SummaryBar
        label={`${cardTitle} · ${
          periodicity === "annuel" ? "formule annuelle" : "formule mensuelle"
        }`}
        total={formatPrice(totalFor(prices, periodicity))}
        buttonLabel="Continuer"
        onContinue={handleContinue}
      />
    </div>
  );
}

export default ServicePlanPage;
